/*
 * Copyright (C) Sitevision AB 2002-2025, all rights reserved
 *
 */
import $ from '@sv/jquery';
import sv from '@sv/core';
import './i18n';

$.fn.sortableViewLayout = function () {
  // Restricts so only views belonging to this view container is processed (not views in views)
  function getViews($layout, $elem) {
    var views = [];
    var allViews = $layout.sortable('toArray');
    for (var position = 0; position < allViews.length; position++) {
      var $view = $elem.find('#' + allViews[position]);
      var $viewContainer = $view.closest('.sv-sortable-view-container');
      if ($viewContainer.attr('id') === $elem.attr('id')) {
        views.push($view.attr('id'));
      }
    }
    return views;
  }

  // Add keyboard support for sortable items
  function setupKeyboardSortable($container) {
    var $sortableItems = $container.find('.sv-view-mouseover');

    $sortableItems.each(function () {
      var $item = $(this);

      // Make items focusable
      if (!$item.attr('tabindex')) {
        $item.attr('tabindex', '0');
      }
    });

    $container
      .off('keydown.sortable')
      .on('keydown.sortable', '.sv-view-mouseover', function (e) {
        var $currentItem = $(this);
        var $items = $container.find('.sv-view-mouseover');
        var currentIndex = $items.index($currentItem);
        var isSelected = $currentItem.hasClass('sv-keyboard-selected');

        switch (e.key) {
          case 'ArrowUp':
            e.preventDefault();
            if (isSelected) {
              // Move item up
              moveItem($currentItem, $container, 'up');
            } else {
              // Navigate up
              if (currentIndex > 0) {
                $items.eq(currentIndex - 1)[0].focus();
              }
            }
            break;

          case 'ArrowDown':
            e.preventDefault();
            if (isSelected) {
              // Move item down
              moveItem($currentItem, $container, 'down');
            } else {
              // Navigate down
              if (currentIndex < $items.length - 1) {
                $items.eq(currentIndex + 1)[0].focus();
              }
            }
            break;
          case ' ':
            // Only prevent default and handle selection if not on a form control
            var target = e.target;
            var isFormControl =
              target.tagName === 'INPUT' ||
              target.tagName === 'SELECT' ||
              target.tagName === 'TEXTAREA' ||
              target.tagName === 'BUTTON' ||
              (target.hasAttribute('role') &&
                (target.getAttribute('role') === 'button' ||
                  target.getAttribute('role') === 'checkbox' ||
                  target.getAttribute('role') === 'radio'));

            if (!isFormControl) {
              e.preventDefault();
              toggleSelection($currentItem, $container);
            }
            break;

          case 'Enter':
            // Enter always handles selection (unless on a button)
            if (
              (e.target.tagName !== 'BUTTON' &&
                !e.target.hasAttribute('role')) ||
              e.target.getAttribute('role') !== 'button'
            ) {
              e.preventDefault();
              toggleSelection($currentItem, $container);
            }
            break;

          case 'Escape':
            // Only clear selection if there's something selected, otherwise let dialog handle it
            if ($container.find('.sv-keyboard-selected').length > 0) {
              e.preventDefault();
              e.stopPropagation();
              clearSelection($container);
            }
            // If nothing is selected, let the event bubble up to close the dialog
            break;

          case 'Home':
            e.preventDefault();
            if (isSelected) {
              moveItem($currentItem, $container, 'first');
            } else {
              $items.first()[0].focus();
            }
            break;

          case 'End':
            e.preventDefault();
            if (isSelected) {
              moveItem($currentItem, $container, 'last');
            } else {
              $items.last()[0].focus();
            }
            break;
        }
      });
  }

  function toggleSelection($item, $container) {
    var $items = $container.find('.sv-view-mouseover');

    if ($item.hasClass('sv-keyboard-selected')) {
      // Deselect
      $item.removeClass('sv-keyboard-selected').attr('aria-selected', 'false');
    } else {
      // Clear other selections and select this item
      $items.removeClass('sv-keyboard-selected').attr('aria-selected', 'false');

      $item.addClass('sv-keyboard-selected').attr('aria-selected', 'true');
    }
  }

  function clearSelection($container) {
    $container
      .find('.sv-view-mouseover')
      .removeClass('sv-keyboard-selected')
      .attr('aria-selected', 'false');
  }

  function moveItem($item, $container, direction) {
    var $items = $container.find('.sv-view-mouseover');
    var currentIndex = $items.index($item);

    switch (direction) {
      case 'up':
        if (currentIndex > 0) {
          $item.insertBefore($items.eq(currentIndex - 1));
          updateSortOrder($container);
        }
        break;
      case 'down':
        if (currentIndex < $items.length - 1) {
          $item.insertAfter($items.eq(currentIndex + 1));
          updateSortOrder($container);
        }
        break;
      case 'first':
        if (currentIndex > 0) {
          $container.prepend($item);
          updateSortOrder($container);
        }
        break;
      case 'last':
        if (currentIndex < $items.length - 1) {
          $container.append($item);
          updateSortOrder($container);
        }
        break;
    }

    // Keep focus on the moved item
    $item[0].focus();
  }

  function updateSortOrder($container) {
    // Trigger the same update logic as the original sortable
    var $sortableViewLayout = $container;
    var views = getViews($container, $sortableViewLayout);
    var newOrder = views.join(',');
    newOrder = newOrder.replace(/svid|,,/g, '');
    newOrder = newOrder.replace(/_/g, '.');

    $.post(
      $sortableViewLayout.data('view-container-url') +
        '&return=none&updateViews=true&viewId=' +
        newOrder
    );
  }

  return this.each(function () {
    var $sortableViewLayout = $(this);
    var divId = $sortableViewLayout.attr('id');
    var horizontal = $sortableViewLayout.hasClass('sv-horizontal');
    var $sortableItems = $sortableViewLayout.find('.sv-view-mouseover');

    if ($sortableViewLayout.hasClass('ui-sortable')) {
      $sortableViewLayout.sortable('destroy');
    }

    // Only proceed if there are at least two sortable items, must be something to sort
    if ($sortableItems.length < 2) {
      return;
    }

    // Setup keyboard support
    setupKeyboardSortable($sortableViewLayout);

    if (
      !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      var connectWith = $sortableViewLayout.data('connect-with');

      $sortableViewLayout.sortable({
        containment: connectWith ? false : '#' + divId,
        connectWith: connectWith ? '.sv-sortable-view-container' : false,
        placeholder: 'sv-view-selection-placeholder',
        forcePlaceholderSize: true,
        distance: 10,
        items: '.sv-view-mouseover',
        opacity: 0.6,
        stop: function (event, ui) {
          ui.item.hide();
          ui.item.show('blind');
          // Clear keyboard selection when mouse sorting ends
          clearSelection($sortableViewLayout);
        },
        update: function (event, ui) {
          var $sortable = $(this);
          if ($sortable.find(ui.item).length > 0) {
            if (horizontal) {
              ui.item.addClass('sv-horizontal-column');
            } else {
              ui.item.removeClass('sv-horizontal-column');
            }
          }

          var views = getViews($sortable, $sortableViewLayout);
          var newOrder = views.join(',');
          newOrder = newOrder.replace(/svid|,,/g, '');
          newOrder = newOrder.replace(/_/g, '.');

          $.post(
            $sortableViewLayout.data('view-container-url') +
              '&return=none&updateViews=true&viewId=' +
              newOrder
          );
          var $viewContainers = $sortableViewLayout.find(
            '.sv-sortable-view-container'
          );

          $viewContainers.push($sortableViewLayout);
        },
      });
    }
  });
};

$(function () {
  var $body = $('body');

  // Setup keyboard support for dialog sortable lists
  function setupDialogKeyboardSortable($container) {
    var $sortableItems = $container.find('.sv-custom-views-list-item');

    $sortableItems.each(function () {
      var $item = $(this);

      // Make items focusable
      if (!$item.attr('tabindex')) {
        $item.attr('tabindex', '0');
      }
    });

    $container
      .off('keydown.dialog-sortable')
      .on('keydown.dialog-sortable', '.sv-custom-views-list-item', function (
        e
      ) {
        var $currentItem = $(this);
        var $items = $container.find('.sv-custom-views-list-item');
        var currentIndex = $items.index($currentItem);
        var isSelected = $currentItem.hasClass('sv-keyboard-selected');

        switch (e.key) {
          case 'ArrowUp':
            e.preventDefault();
            if (isSelected) {
              // Move item up
              if (currentIndex > 0) {
                $currentItem.insertBefore($items.eq(currentIndex - 1));
                $currentItem[0].focus();
              }
            } else {
              // Navigate up
              if (currentIndex > 0) {
                $items.eq(currentIndex - 1)[0].focus();
              }
            }
            break;

          case 'ArrowDown':
            e.preventDefault();
            if (isSelected) {
              // Move item down
              if (currentIndex < $items.length - 1) {
                $currentItem.insertAfter($items.eq(currentIndex + 1));
                $currentItem[0].focus();
              }
            } else {
              // Navigate down
              if (currentIndex < $items.length - 1) {
                $items.eq(currentIndex + 1)[0].focus();
              }
            }
            break;

          case ' ':
            // Only prevent default and handle selection if not on a form control
            var target = e.target;
            var isFormControl =
              target.tagName === 'INPUT' ||
              target.tagName === 'SELECT' ||
              target.tagName === 'TEXTAREA' ||
              target.tagName === 'BUTTON' ||
              (target.hasAttribute('role') &&
                (target.getAttribute('role') === 'button' ||
                  target.getAttribute('role') === 'checkbox' ||
                  target.getAttribute('role') === 'radio'));

            if (!isFormControl) {
              e.preventDefault();
              toggleDialogSelection($currentItem, $container);
            }
            break;

          case 'Enter':
            // Enter always handles selection (unless on a button)
            if (
              (e.target.tagName !== 'BUTTON' &&
                !e.target.hasAttribute('role')) ||
              e.target.getAttribute('role') !== 'button'
            ) {
              e.preventDefault();
              toggleDialogSelection($currentItem, $container);
            }
            break;

          case 'Escape':
            // Only clear selection if there's something selected, otherwise let dialog handle it
            if ($container.find('.sv-keyboard-selected').length > 0) {
              e.preventDefault();
              e.stopPropagation();
              clearDialogSelection($container);
            }
            // If nothing is selected, let the event bubble up to close the dialog
            break;
        }
      });
  }

  function toggleDialogSelection($item, $container) {
    var $items = $container.find('.sv-custom-views-list-item');

    if ($item.hasClass('sv-keyboard-selected')) {
      // Deselect
      $item.removeClass('sv-keyboard-selected').attr('aria-selected', 'false');
    } else {
      // Clear other selections and select this item
      $items.removeClass('sv-keyboard-selected').attr('aria-selected', 'false');

      $item.addClass('sv-keyboard-selected').attr('aria-selected', 'true');
    }
  }

  function clearDialogSelection($container) {
    $container
      .find('.sv-custom-views-list-item')
      .removeClass('sv-keyboard-selected')
      .attr('aria-selected', 'false');
  }

  $body.on('click', '.sv-view-selector', function () {
    var $viewSelector = $(this),
      href = $viewSelector.attr('href'),
      id = $viewSelector.attr('id').substr(15); // Substring prefix 'sv-selector-id-'

    var $dialogContainer = $('#sv-view-selector-dialog-' + id);

    if ($dialogContainer.length > 0) {
      $dialogContainer.svDialog('open');
    } else {
      $dialogContainer = $('<div/>', {
        id: 'sv-view-selector-dialog-' + id,
      });

      $dialogContainer.on('open:dialog.sv-dialog', function () {
        var $this = $(this);
        var $customViewsList = $this.find('.sv-custom-views-list');

        if ($customViewsList.length) {
          $customViewsList.sortable({
            containment: $this.closest('.sv-dialog'),
            axis: 'y',
            delay: 300,
          });

          // Add keyboard support to dialog sortable
          setupDialogKeyboardSortable($customViewsList);
        }
      });

      $dialogContainer.svDialog({
        title: sv.i18n.getText('util.viewutil', 'selectView'),
        open: true,
        url: href,
        modal: true,
        closeButtonLabel: sv.i18n.getText('common', 'close'),
        onClose: function () {
          var $el = $('#' + id);
          if ($el.length) {
            // $viewSelector might be stale
            var opener = $el.find('#' + $viewSelector[0].id);
            if (opener.length) {
              // Focus the view selector that opened the dialog
              opener[0].focus();
            }
          }
        },
        buttons: [
          {
            text: sv.i18n.getText('common', 'save'),
            type: 'primary',
            callback: function () {
              var $form = $dialogContainer.find('form');
              $.post(href, $form.serialize(), function () {
                $.get(sv[id].layoutURL, function (data) {
                  var $el = $('#' + id);

                  $el.html(data);
                  $('.sv-sortable-view-container').sortableViewLayout();
                  $dialogContainer.svDialog('close');
                  $el.find('#' + $viewSelector[0].id)[0].focus();
                });
              });
            },
          },
          {
            text: sv.i18n.getText('common', 'cancel'),
            type: 'link',
            callback: function () {
              $dialogContainer.svDialog('close');
            },
          },
        ],
      });
    }

    return false;
  });

  function buildLayoutURL($element, $parent, state) {
    var parentId = $parent.attr('id').replace('svid', '').replace('_', '.'),
      href = $element.attr('href'),
      pageId = href.substring(href.indexOf('page=') + 5, href.length);

    return (
      '/' +
      pageId +
      '/' +
      parentId +
      '.htm?sv.state=' +
      state +
      '&sv.url=' +
      parentId
    );
  }

  $body.on('click', '.sv-layout-minimize', function () {
    var $this = $(this),
      $parent = $this.closest('[id^=svid10_]'),
      url = buildLayoutURL($this, $parent, 'minimized');
    $.get(url, function (data) {
      $this.closest('.sv-toolbar').siblings().hide();
      $parent.html(data);
    });

    return false;
  });

  $body.on('click', '.sv-layout-restore', function () {
    var $this = $(this),
      $parent = $this.closest('[id^=svid10_]'),
      url = buildLayoutURL($this, $parent, 'normal');
    $.get(url, function (data) {
      $parent.html(data).show();
    });

    return false;
  });

  $body.on('click', '.sv-portlet-restore', function () {
    //Fadein - normalt state on the layout
    var $this = $(this),
      $parent = $this.closest('.pagecontent'),
      parentId = $parent.attr('id').replace('svid', '').replace('_', '.'),
      href = $this.attr('href'),
      pageId = href.substring(href.indexOf('page=') + 5, href.length),
      query = href.substring(href.indexOf('?'), href.length),
      url = '/' + pageId + '/' + parentId + '.htm' + query;

    $.get(url, function (data) {
      $parent.html(data).show();
    });

    return false;
  });

  var $sortableContainers = $('.sv-sortable-view-container');

  if ($sortableContainers.length) {
    if ($.ui && $.ui.sortable) {
      $sortableContainers.sortableViewLayout();
    } else {
      import(
        /* webpackChunkName: "viewUtilPlugins" */ './vendor/viewUtilPlugins.js'
      ).then(() => $sortableContainers.sortableViewLayout());
    }
  }
});
